import React, { useState } from 'react';
import _chunk from 'lodash/chunk';

import { Container } from '@crehana/ui';
import SliderGrid from '@crehana/ui/dist/Slider/SliderGrid';

import FutureLiveCard, {
  FutureLiveCardProps,
} from '@crehana/web/dist/components/Cards/FutureLiveCard';

import { useCrehanaLiveTranslations } from 'Jsx/CrehanaLive/hooks';

import { useMe } from 'Jsx/ContextApis/AuthContext';

import { LiveNode } from 'Jsx/CrehanaLive/graphql/types/LiveNode';

import { CREHANA_LIVE_AMPLITUDE_PAGE_NAME } from '../constants';

interface NextLiveProps {
  lives: LiveNode[];
  enrollToLive?: (liveId: number) => Promise<void>;
}

const NextLives: React.FC<NextLiveProps> = ({ lives, enrollToLive }) => {
  const { t } = useCrehanaLiveTranslations();

  const { me } = useMe();

  const [subscriptionIsLoading, setSubscriptionIsLoading] = useState(false);

  if (!lives.length) {
    return null;
  }

  const onSubscribeToLive: FutureLiveCardProps['onSubscribeToLive'] = live => {
    if (live.originalId && enrollToLive) {
      setSubscriptionIsLoading(true);
      enrollToLive(live.originalId)
        .then(() => setSubscriptionIsLoading(false))
        .catch(() => setSubscriptionIsLoading(false));
    }
  };

  return (
    <Container>
      <h2 className="font-h4 text-white text-center mb-32">
        {t('KNOW_CLASS_LIVE')}
      </h2>
      <SliderGrid
        itemsPerPage={{ xs: 1, sm: 2, md: 3, lg: 3 }}
        mobilePaginationProps={{ type: 'dots' }}
        desktopPaginationProps={{ type: 'dots' }}
        desktopPaginationSelector=".next-lives-pag"
        dark
      >
        {lives.map(live => (
          <FutureLiveCard
            key={`next-live-${live.originalId}`}
            {...live}
            me={me}
            onSubscribeToLive={onSubscribeToLive}
            subscriptionIsLoading={subscriptionIsLoading}
            source={CREHANA_LIVE_AMPLITUDE_PAGE_NAME}
            sourceDetail="Next Lives"
          />
        ))}
      </SliderGrid>
      <div className="next-lives-pag w-full flex items-center justify-center mt-24" />
    </Container>
  );
};

export default NextLives;
